import {
  nodeToggleView,
  type NodeToggleMetric,
  type NodeToggleRequest,
  type NodeToggleView,
} from '@occ/contracts';
import { get, put } from '../api/http';
import { ROUTES } from '../api/routes';

/**
 * Interruptores por nodo (M15 §4, ampliado a consumo): "avisarme si este nodo
 * se cae", "avisarme si la CPU está alta", "avisarme si la memoria está alta".
 * Por debajo cada uno crea o desactiva una `AlertRule` de ámbito nodo — el
 * panel no necesita saberlo, solo lee y escribe este estado resumido por
 * métrica.
 */

export const fetchNodeToggle = async (
  nodeId: string,
  metric: NodeToggleMetric,
): Promise<NodeToggleView> => nodeToggleView.parse(await get(ROUTES.nodeToggle(nodeId, metric)));

export const setNodeToggle = async (
  nodeId: string,
  metric: NodeToggleMetric,
  request: NodeToggleRequest,
): Promise<NodeToggleView> =>
  nodeToggleView.parse(await put(ROUTES.nodeToggle(nodeId, metric), request));
